<div class="fuse-vertical-navigation-item-wrapper" [class.fuse-vertical-navigation-item-has-subtitle]="!!item.subtitle"
    [ngClass]="item.classes?.wrapper">

    <div class="fuse-vertical-navigation-item" [ngClass]="{'fuse-vertical-navigation-item-disabled': item.disabled}"
        [matTooltip]="item.tooltip || ''" (click)="toggleCollapsable()">

        <!-- Icon -->
        <ng-container *ngIf="item.icon">
            <mat-icon class="fuse-vertical-navigation-item-icon" [ngClass]="item.classes?.icon" [svgIcon]="item.icon">
            </mat-icon>
        </ng-container>

        <!-- Title & Subtitle -->
        <div class="fuse-vertical-navigation-item-title-wrapper">
            <div class="fuse-vertical-navigation-item-title">
                <span [ngClass]="item.classes?.title">
                    {{item.title}}
                </span>
            </div>
            <ng-container *ngIf="item.subtitle">
                <div class="fuse-vertical-navigation-item-subtitle">
                    <span [ngClass]="item.classes?.subtitle">
                        {{item.subtitle}}
                    </span>
                </div>
            </ng-container>
        </div>

        <!-- Badge -->
        <ng-container *ngIf="item.badge">
            <div class="fuse-vertical-navigation-item-badge">
                <div class="fuse-vertical-navigation-item-badge-content" [ngClass]="item.badge.classes">
                    {{item.badge.title}}
                </div>
            </div>
        </ng-container>

        <!-- Arrow -->
        <mat-icon class="fuse-vertical-navigation-item-arrow icon-size-4" [svgIcon]="'heroicons_solid:chevron-right'">
        </mat-icon>

    </div>

</div>

<div class="fuse-vertical-navigation-item-children" *ngIf="!isCollapsed && !chainage" @expandCollapse>

    <ng-container *ngFor="let item of item.children; trackBy: trackByFn">

        <!-- Skip the hidden items -->
        <ng-container *ngIf="(item.hidden && !item.hidden(item)) || !item.hidden">

            <!-- Basic -->
            <ng-container *ngIf="item.type === 'basic'">
                <fuse-vertical-navigation-basic-item [item]="item" [name]="name"></fuse-vertical-navigation-basic-item>
            </ng-container>

            <!-- Collapsable -->
            <ng-container *ngIf="item.type === 'collapsable'">
                <fuse-vertical-navigation-collapsable-item [item]="item" [name]="name" [autoCollapse]="autoCollapse">
                </fuse-vertical-navigation-collapsable-item>
            </ng-container>

            <!-- Divider -->
            <ng-container *ngIf="item.type === 'divider'">
                <fuse-vertical-navigation-divider-item [item]="item" [name]="name">
                </fuse-vertical-navigation-divider-item>
            </ng-container>

            <!-- Group -->
            <ng-container *ngIf="item.type === 'group'">
                <fuse-vertical-navigation-group-item [item]="item" [name]="name"></fuse-vertical-navigation-group-item>
            </ng-container>

            <!-- Spacer -->
            <ng-container *ngIf="item.type === 'spacer'">
                <fuse-vertical-navigation-spacer-item [item]="item" [name]="name">
                </fuse-vertical-navigation-spacer-item>
            </ng-container>

        </ng-container>

    </ng-container>

</div>


<div class="fuse-vertical-navigation-item-children" *ngIf="!isCollapsed && chainage" @expandCollapse>


    <!-- Basic -->
    <ng-container>
        <form class="w-full max-w-sm">
            <div class="md:flex md:items-center mb-3">
                <div class="md:w-1/3">
                    <label class="block text-white md:text-right mb-1 md:mb-0 pr-4" for="inline-full-name">
                        {{dashboardService.translate('Start')}}
                    </label>
                </div>
                <div class="md:w-2/5">
                    <input step="0.05" [placeholder]="shiftDataService.defaultMinChainage"
                        [min]="shiftDataService.defaultMinChainage" [max]="shiftDataService.defaultMaxChainage-1"
                        [value]="chainageLowValue" (input)="chainageLowValue=+$event.target.value" class="bg-white appearance-none border-2 border-gray-200 rounded w-full py-2 px-4
                               text-gray-700 leading-tight focus:outline-none focus:bg-white "
                        [ngClass]="chainageLowValue>=shiftDataService.defaultMinChainage?'':'bg-red-300  border-red-500'"
                        id="inline-full-name" type="number" value="">
                </div>
            </div>
            <div class="md:flex md:items-center mb-3">
                <div class="md:w-1/3">
                    <label class="block text-white md:text-right mb-1 md:mb-0 pr-4" for="inline-password">
                        {{dashboardService.translate('End')}}
                    </label>
                </div>
                <div class="md:w-2/5">
                    <input step="0.05" [placeholder]="shiftDataService.defaultMaxChainage" [min]="chainageLowValue"
                        [max]="shiftDataService.defaultMaxChainage" [value]="chainageHighValue"
                        (input)="chainageHighValue=+$event.target.value"
                        class="bg-white appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white "
                        [ngClass]="chainageHighValue>=chainageLowValue&&
                                chainageHighValue<=shiftDataService.defaultMaxChainage?'':'bg-red-300  border-red-500'"
                        id="inline-password" type="number" placeholder="">
                </div>
            </div>
            <div class="md:flex md:items-center">
                <div class="md:w-1/3"></div>
                <div class="md:w-2/5 ">
                    <button (click)="onChainageFilterClick()" [disabled]="chainageHighValue<chainageLowValue ||
                                chainageHighValue>shiftDataService.defaultMaxChainage ||
                                chainageLowValue>shiftDataService.defaultMaxChainage||
                                chainageLowValue<shiftDataService.defaultMinChainage" class="w-full shadow bg-yellow  focus:shadow-outline focus:outline-none
                             text-black py-2 px-4 rounded disabled:bg-amber-200" type="button">
                        {{dashboardService.translate('Filter')}}
                    </button>
                </div>
                <div class="md:w-1/4">
                    <button (click)="onResetChainageFiltersClick()"
                        class="shadow bg-transparent  focus:shadow-outline focus:outline-none text-black py-2 px-4 rounded"
                        type="button">
                        <mat-icon [svgIcon]="'custom:refresh'"></mat-icon>
                    </button>
                </div>

            </div>
        </form>
    </ng-container>
    <!--    <ng-container *ngIf="item.type === 'basic'">-->
    <!--        <fuse-vertical-navigation-basic-item-->
    <!--            [item]="item"-->
    <!--            [name]="name"></fuse-vertical-navigation-basic-item>-->
    <!--    </ng-container>-->


</div>